import React from 'react';
import { Tooltip } from '@aibuild/ui';
import { FieldLabel } from './nodeCommon.styled';
import { InfoIcon, LabelTrigger } from './NodeFieldLabel.styled';

export interface NodeFieldLabelProps {
  label: string;
  /** Optional explanatory copy surfaced as a hover tooltip on the label.
   *  Null / blank renders a plain label with no tooltip affordance. */
  hint?: string | null;
  /** Test id on the tooltip trigger; derived per field by the caller. */
  dataTestId?: string;
}

/**
 * Config-field label. When a `hint` is present it renders a small info glyph
 * and wires the shared `@aibuild/ui` `Tooltip` (portaled so it escapes the
 * node card's overflow clipping) on hover/focus. Otherwise it's the plain
 * styled `FieldLabel`, byte-for-byte as before.
 */
const NodeFieldLabel: React.FC<NodeFieldLabelProps> = ({
  label,
  hint,
  dataTestId,
}) => {
  const trimmed = hint?.trim();
  if (!trimmed) {
    return <FieldLabel>{label}</FieldLabel>;
  }
  return (
    <FieldLabel>
      <Tooltip content={trimmed} placement="top" portal dataTestId={dataTestId}>
        <LabelTrigger>
          {label}
          <InfoIcon className="material-symbols-rounded" aria-hidden="true">
            info
          </InfoIcon>
        </LabelTrigger>
      </Tooltip>
    </FieldLabel>
  );
};

export default NodeFieldLabel;
